import financeiroContaBancaria from './conta-bancaria';

export default {
  financeiroContaBancaria,
};
